function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.20801,
  y: 10.3872,
  width: 8.55417,
  height: 1.3,
  rx: 0.65,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3.20801,
  y: 3.22363,
  width: 4.63351,
  height: 1.3,
  rx: 0.65,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.20801,
  y: 6.80542,
  width: 2.85139,
  height: 1.3,
  rx: 0.65,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3.20801,
  y: 13.969,
  width: 8.55417,
  height: 1.3,
  rx: 0.65,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.41559 0H1.40342C0.628322 0 0 0.631417 0 1.41033V16.7673C0 17.5462 0.628322 18.1776 1.40342 18.1776H13.5664C14.3415 18.1776 14.9698 17.5462 14.9698 16.7673V8.23818H13.5664V16.591C13.5664 16.6377 13.5479 16.6826 13.515 16.7156C13.4821 16.7487 13.4375 16.7673 13.3909 16.7673H1.57885C1.53232 16.7673 1.4877 16.7487 1.4548 16.7156C1.4219 16.6826 1.40342 16.6377 1.40342 16.591V1.58662C1.40342 1.53987 1.4219 1.49503 1.4548 1.46197C1.4877 1.42891 1.53232 1.41033 1.57885 1.41033H6.41559V0Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7388 1.01973L15.0133 0.298487C14.6125 -0.0994955 13.9632 -0.0994955 13.5624 0.298487C13.5624 0.298487 7.85796 5.96298 7.77241 6.30659L7.51576 7.32722C7.42791 7.67527 7.53035 8.04361 7.78557 8.29735C8.04079 8.55109 8.41129 8.65293 8.76137 8.56559L9.78796 8.31043C10.1302 8.22198 15.7388 2.46562 15.7388 2.46562C16.1391 2.06715 16.1391 1.42161 15.7388 1.02313V1.01973ZM10.1951 6.53126L9.4936 5.83383L9.46965 5.81342L14.2878 1.02327L15.0133 1.74451L10.1951 6.53126Z",
  fill: "white"
});

function SvgFavlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavlist);
export default __webpack_public_path__ + "static/media/favlist.702b1cdd.svg";
export { ForwardRef as ReactComponent };